<div class="page-container flex items-center justify-center min-h-[calc(100vh-4rem)] bg-white">
  <div class="relative w-full max-w-md border border-dc-navy mt-10">
    <div class="form-card px-6 xl:!pr-6 xl:!pl-6">
      <div class="mx-auto w-full max-w-lg min-h-[260px] flex items-center justify-center">
        @if (isSubmitting) {
          <i class="fas fa-spinner fa-spin text-dc-navy text-3xl"></i>
        } @else if (showLinkPrompt) {
          <div class="w-full text-center text-dc-navy">
            <h1 class="text-2xl font-bold mb-4">
              {{ 'UAEPASS_LINK_TITLE' | translate }}
            </h1>
            <p class="mb-3">
              {{ 'UAEPASS_LINK_DESC_PREFIX' | translate }}
              <span class="font-semibold">UAE PASS</span>
              {{ 'UAEPASS_LINK_DESC_SUFFIX' | translate }}
            </p>
            <p class="mb-3">
              {{ 'UAEPASS_LINK_EXISTING_PREFIX' | translate }}
              <span class="font-semibold">{{ matchedUser }}</span>.
            </p>
            <p class="mb-6">
              {{ 'UAEPASS_LINK_ACTION_PREFIX' | translate }}
              <span class="font-semibold">{{ matchedUser }}</span>
              {{ 'UAEPASS_LINK_ACTION_SUFFIX' | translate }}
            </p>
            <div class="field-control !mb-4">
              <app-button
                type="button"
                classesName="btn-primary-big w-full"
                class="block w-full"
                [label]="'UAEPASS_LINK_NEXT' | translate"
                (onBtnClick)="proceedToLink()"
              ></app-button>
            </div>
            <button type="button" class="text-dc-navy underline" (click)="backToSignIn()">
              {{ 'UAEPASS_LINK_BACK' | translate }}
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</div>
